export const screenerCopyEn = {
    start: "Start",
    starting: "Starting...",
    checking: "Checking your answers...",
    notFoundTitle: "This link is not working",
    notFoundBody: "The questionnaire may have closed. Speak to the team who gave you this link.",
    eligibleTitle: "You can join",
    eligibleBody: "Create your account to get started.",
    ineligibleTitle: "This is not right for you",
    ineligibleBody:
        "Thank you for answering. Based on your answers, you do not meet the criteria. If you have questions, speak to the team who gave you this link.",
    continueToSignUp: "Continue to sign up",
    scanOnPhone: "Or scan this code with your phone camera to sign up on your phone.",
    startAgain: "Start again",
};
